export function makeWord(prefix: string, suffix: string) {
  if (prefix.length > 0 && suffix.length > 0) {
    return `${prefix} ${suffix}`;
  }
  if (prefix.length > 0) {
    return `${prefix}`;
  }
  if (suffix.length > 0) {
    return `${suffix}`;
  }

  return '';
}
